// /sinyal/:fund route — C04 Karar Masası.
// Deep-link uyumlu: Telegram push'tan doğrudan açılabilir (örn.
// https://aifon.example/sinyal/TLY). Geri ok ya da ✕ → ana sayfaya döner.
// Dönüşte ilgili sinyal id'si `markEvaluated()` ile App state'ine yazılır.

import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MOCK_SIGNAL_DETAILS } from "../data/mockSinyal";
import KararMasasi from "../components/KararMasasi";

interface Props {
  /** Fund kodu bazlı işaretleme — App-level evaluatedFunds Set'i. */
  markEvaluated: (fund: string) => void;
}

export default function SinyalDetay({ markEvaluated }: Props) {
  const { fund } = useParams<{ fund: string }>();
  const navigate = useNavigate();
  const code = (fund ?? "").toUpperCase();
  const detail = MOCK_SIGNAL_DETAILS[code];

  // Açılır açılmaz ilgili sinyal kartını "değerlendirildi" işaretle —
  // sketch'te `goDecision()` aynı anda hem ekranı açıyor hem rozeti veriyor.
  useEffect(() => {
    if (!detail) return;
    markEvaluated(detail.fund);
  }, [detail, markEvaluated]);

  if (!detail) {
    return (
      <main
        className="min-h-screen flex flex-col items-center justify-center px-6 mx-auto text-center"
        style={{ maxWidth: 430 }}
      >
        <p className="text-ink-300 mb-3">
          <span className="fon-dili">{code || "?"}</span> için karar masası
          bulunamadı.
        </p>
        <button
          type="button"
          onClick={() => navigate("/")}
          className="btn"
        >
          Ana sayfaya dön
        </button>
      </main>
    );
  }

  return <KararMasasi detail={detail} onClose={() => navigate("/")} />;
}
